import { useClearErrors } from "@42.nl/react-error-store";
import { Button, SubmitButton } from "@42.nl/ui";
import { Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import CheckboxField from "../components/Checkbox/CheckboxField";

export type YearFormData = {
  id?: number;
  externalId?: string;
  code?: string;
  dutchName?: string;
  englishName?: string;
  startDate?: Date;
  endDate?: Date;
  active?: boolean;
};

type Props = {
  initialValues: YearFormData;
  onCancel: () => void;
  onSubmit: (data: YearFormData) => void;
};

export default function YearForm(props: Readonly<Props>) {
  const { onCancel, onSubmit, initialValues } = props;

  // Clear previous back-end errors if this form was shown before
  useClearErrors();
  const { t } = useTranslation(["year", "translation"]);

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={initialValues}
      render={({ handleSubmit, submitting }) => (
        <form onSubmit={handleSubmit}>
          <CheckboxField
            name="active"
            label={t("year:COLUMNS.ACTIVE")}
            className="mb-3"
          />

          <div className="mb-2 d-flex gap-2 justify-content-end">
            <Button onClick={onCancel} color="secondary">
              {t("translation:CANCEL")}
            </Button>
            <SubmitButton inProgress={submitting}>
              {t("translation:SUBMIT_BUTTON")}
            </SubmitButton>
          </div>
        </form>
      )}
    />
  );
}
